export const SET_USER = "SET_USER";
export const GET_USERS = "GET_USERS";
export const UPDATE_USER_NAME = "UPDATE_USER_NAME";
export const SET_GLOBAL_TIME_PERIOD = "SET_GLOBAL_TIME_PERIOD";
export const GET_GLOBAL_TIME_PERIOD_FROM_STORAGE = "GET_GLOBAL_TIME_PERIOD_FROM_STORAGE";
